"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const TextBase_1 = __importDefault(require("./TextBase"));
const Text = ({ children, margin = 'default', color, style, variant = 'normalBody', numberOfLines, }) => {
    return (react_1.default.createElement(TextBase_1.default, { numberOfLines: numberOfLines, color: color, style: react_native_1.StyleSheet.flatten([marginStyles[margin], style]), size: variants[variant].size, weight: variants[variant].weight, children: children }));
};
exports.default = Text;
const marginStyles = react_native_1.StyleSheet.create({
    default: {
        marginBottom: styles_1.getSpacing(),
    },
    dense: {
        marginBottom: styles_1.getSpacing(0.5),
    },
    none: {
        marginBottom: 0,
    },
});
const variants = {
    title: {
        size: 1.167,
        weight: 'bold',
    },
    cardTitle: {
        size: 1,
        weight: 'bold',
    },
    subtitle: {
        size: 0.833,
        weight: 'bold',
    },
    normalBody: {
        size: 1,
        weight: 'regular',
    },
    mediumBody: {
        size: 1,
        weight: 'medium',
    },
    caption: {
        size: 0.916,
        weight: 'regular',
    },
};
